import { ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import { StarOutlineTwoTone, StarTwoTone } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { useSetFavoriteQueryMutation } from '@api/Trinium/Endpoints/BoardQueries/slice';
import { useAppDispatch, useAppSelector } from '@reduxStore';
import { BoardQuery } from '@api/Trinium/types';
import { QueryWithCount } from './QueryWithCount';
import { queueUncontrolledToast } from '@toast';
import { useEffect } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { defaultFilterModel } from '@components/DataGrid/Dispatch/types';
import { defaultAllOpenQuery } from '@api/Trinium/Endpoints/BoardQueries/types';

import styles from './QuerySelector.module.css';

export function QueryListItem(props: {
	terminalNumber: string;
	query: BoardQuery;
	isSelected: boolean;
	closeMenu: () => void;
	isDefaultQuery?: boolean;
}) {
	const navigate = useNavigate();
	const terminalNumber = useAppSelector((state) => state.applicationState.selectedTerminal?.number as string);
	const appDispatch = useAppDispatch();
	const gridApiRef = useGridApiContext();
	const [post, { isLoading, isError }] = useSetFavoriteQueryMutation();
	const isDefaultAllOpenQuery = props.query.id === defaultAllOpenQuery.id;

	const onFavoriteClick = () => {
		if (!isLoading) {
			void post({
				terminalNumber: terminalNumber,
				id: props.query.id,
				isFavorite: !props.query.isFavorite
			});
		}
	};

	useEffect(() => {
		if (isError) {
			appDispatch(
				queueUncontrolledToast({
					type: 'message',
					message: 'Unable to favorite the query, if the problem persists please contact IT Support.',
					severity: 'error',
					autoCloseMs: 5000
				})
			);
		}
	}, [isError, appDispatch]);

	return (
		<ListItem
			key={props.query.id}
			className={`${styles['query-item']} ${props.isSelected ? styles.active : ''}`}
		>
			<ListItemIcon
				title='Favorite Query'
				className={styles['favorite-icon']}
				onClick={onFavoriteClick}
			>
				{!isDefaultAllOpenQuery ? (
					props.query.isFavorite ? (
						<StarTwoTone
							fontSize='small'
							className={styles.favorited}
						/>
					) : (
						<StarOutlineTwoTone
							fontSize='small'
							className={styles.default}
						/>
					)
				) : (
					<></>
				)}
			</ListItemIcon>
			<ListItemButton
				onClick={() => {
					/** When a query changes, reset the filter model */
					gridApiRef.current.setFilterModel(defaultFilterModel);
					void navigate(`/${props.terminalNumber}/Board${!props.isDefaultQuery ? `/${props.query.name}` : ''}`);
					props.closeMenu();
				}}
				className={styles['query-item-btn']}
			>
				<QueryWithCount
					terminalNumber={props.terminalNumber}
					query={props.query}
				/>
			</ListItemButton>
		</ListItem>
	);
}
